<template>
    <div style="width:100%;">

        <div class="container" style="width:50%;text-align:center;">
            <div class="fade_img" style="padding-bottom:20px;">
                <img width="500px" height="auto" 
                src="http://www.mis-implants.com/img/product-logos/CONNECT.svg" />
            </div>
            <div class="split-text subtitle">
                <p>MIS CONNECT: Versatile One-Time Solution for Conical Connection Implants. 
                    The MIS CONNECT is a stay-in abutment system which enables avoiding interference with the peri-implant gingival seal. 
                </p>
            </div>  
        </div>
        <div class="xrBtn">
            <a href="/Products/MGUIDE" class="white_btn animation_up">
            <span class="title">Read More</span><i class="fal fa-chevron-right pl-s" ></i>
            </a>
        </div>
    </div>
</template>
<style>    
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    .fade_img
    {
        opacity: 0;
        transition:all ease-in-out 1s;
        transition-delay: 0.1s;
        transform: translateY(20px);
    }
    .reveal.active .fade_img
    {      
        opacity: 1;
        transform: translateY(0px);
    }
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/

  .split-text.subtitle .xLine .xLineText
  {
    font-weight: 300 !important;
  }
  .split-text.title .xLine .xLineText
  {
    font-weight: 600 !important;
  }
  .xrImgCircleItems
  {
    display: grid;
    justify-items: center;
    grid-template-columns: repeat(6, minmax(115px, 1fr));  
    padding-top:30px;clear:both;width:50%;margin:auto;
  }
  .xrImgCircle
  {
    opacity: 0;
    clip-path: circle(50px at center);
    position: relative;
    background-color:rgba(255,255,255,0.15);
    width: 120px;height: 120px;
  }

  .xrImgCircle .xrImg
  {
    opacity: 1;
    position: absolute;
    width: 120px;height: 120px;
    background-size: 115%;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center center;    
    clip-path: circle(40px at center);
    transition: all ease-in-out 0.3s;
  }
  .xrImgCircle:hover .xrImg
  {
    __clip-path: circle(35px at center);
  }
    .clip-circle {
    clip-path: circle(40px at center);
    /* OLD VALUE example: circle(245px, 140px, 50px); */
    /* Yep, even the new clip-path has deprecated stuff. */
    }

  .white_btn
  {
    opacity:0;
    cursor: pointer;
    position: relative;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    color: #fff !important;
    border: 1px solid #ddd;
    text-align: left;
    background-color:transparent;
    padding: 25px 25px;
    border-radius: 40px;
    height: 40px;
    font-size: 14px;
  }
  .white_btn span
  {
    line-height: 1;
    display: inline-block;
    vertical-align: middle;    
  }
  .xrBtn
  {
    padding-top:20px;color:#fff;width:50%;margin:auto;text-align:center;
  }
</style>




<script>
import { mapActions, mapState } from "vuex";
import { splitLines }         from "@/utils";

export default {
  name: "hpPros",
  mounted() {
    this.initText();
  },
  methods: {
    initText()
    {
      var splitBlocks = document.getElementsByClassName('split-text');
      for (var i = 0; i < splitBlocks.length; i++) {
        splitLines(splitBlocks[i]); 
      }
    },
  },
  computed: {
    ...mapState(["pageLayoutData", "locale", "dirtyHome"]),
  }
};
</script>

